import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./logout.scss";
import { logout } from "../../features/auth/authThunk";
import { logoutUser } from "../../features/auth/authSlice";
import { persistor } from "../../app/store";

const Logout = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Function to handle logout
  const handleLogout = async () => {
    try {
      // First, try to call the logout API
      await dispatch(logout()).unwrap();
    } catch (error) {
      console.error("Logout API error:", error);
      // Even if API call fails, continue with local logout
    } finally {
      // Dispatch logoutUser action to trigger the state reset in rootReducer
      dispatch(logoutUser());
      
      // Purge the persistor to clear persisted state
      persistor.purge();
      
      // Clear localStorage authToken
      sessionStorage.removeItem("authToken");
      
      // Close the dialog
      setOpen(false);
      
      // Navigate to login page
      navigate("/");
    }
  };

  return (
    <div className="logoutDialog">
      <p className="logoutDialog__head">Sei sicuro di voler uscire?</p>
      <div className="logoutDialog__btn">
        <button
          className="logoutDialog__btnInner exit"
          onClick={handleLogout}
        >
          Esci
        </button>
        <div
          className="logoutDialog__btnInner stay"
          onClick={() => setOpen(!open)}
        >
          Rimani connesso
        </div>
      </div>
    </div>
  );
};

export default Logout;